import { useEffect } from "react";

interface KeyPressEvent {
  key: string;
  handle: (event: KeyboardEvent) => void;
  modifierKey?: string;
}

export default function useKey(keys: KeyPressEvent[]) {
  const listener = (event: KeyboardEvent) => {
      const modifierKeys: {
        [key: string]: any;
      } = {
          ctrl: event?.ctrlKey,
          shift: event.shiftKey,
          alt: event?.altKey,
      }
      const key = event.key?.toLowerCase();

      if (keys?.length) {
          const keyPressed = keys.find(item => (item?.key?.toLowerCase() === key) && item?.handle) 

          if (keyPressed) {
              if (!keyPressed.modifierKey || (keyPressed.modifierKey && modifierKeys?.[keyPressed.modifierKey])) {
                  keyPressed.handle(event)
              }
          }
      }
  }

  useEffect(() => {
      document.addEventListener('keydown', listener);
  
      // Clean up when component unmounts
      return function cleanup() {
        document.removeEventListener('keydown', listener);
      }
  });
}